import * as React from "react";
const SvgVector = (props) => /* @__PURE__ */ React.createElement("svg", { width: 191, height: 110, viewBox: "0 0 191 110", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.514282 108.809L190 1.0625", stroke: "#141689", strokeWidth: 1.5 }));
export default SvgVector;
